<script lang="ts">
  import { browser } from "$app/environment";
  import ChevronDown from "virtual:icons/mdi/chevron-down";
  import ChevronRight from "virtual:icons/mdi/chevron-right";
  import type { NavItem } from "@/src/types/components/Nav";

  export let navitem: NavItem;
  export let index: number;
  export let isActive: boolean = false;
  export let dropdownStates: boolean[] = [];
  export let toggleDropdown: (index: number, forceState?: boolean) => void;
</script>

<li class="relative group first:group-first">
  {#if navitem.subitems}
    <!-- Item with dropdown -->
    <button
      type="button"
      class="group-first:md:pl-0 flex gap-1 justify-between items-center px-3 py-2 md:py-0 w-full h-full text-nav font-bold text-white md:justify-start visited:text-white hover:text-gray-200 md:hover:bg-transparent
             transition-colors duration-300 ease-in-out rounded-t-sm
             {dropdownStates[index] ? 'bg-brand-light md:bg-transparent' : ''}"
      on:click={() => toggleDropdown(index)}
      on:mouseenter={() => {
        if (browser && innerWidth >= 768) toggleDropdown(index, true);
      }}>
      {navitem.name}
      <span class="md:hidden">
        <ChevronRight
          class="w-6 h-6 transition-transform duration-300 {dropdownStates[index] ? 'rotate-90' : 'rotate-0'}" />
      </span>
      <span class="hidden md:inline">
        <ChevronDown class="w-6 h-6" />
      </span>
    </button>

    <!-- Dropdown menu -->
    {#if browser ? (innerWidth < 768 ? dropdownStates[index] : true) : false}
      <div
        role="menu"
        tabindex="0"
        class="w-full p-0 m-0 bg-white border-white border-2 z-10
               overflow-hidden transition-all duration-300 ease-out rounded-b-sm
               {browser && innerWidth < 768
          ? dropdownStates[index]
            ? 'max-h-96 opacity-100'
            : 'max-h-0 opacity-0'
          : ''}
               md:absolute md:left-0 md:top-full md:w-52 md:hidden group-hover:md:block md:shadow-md"
        on:mouseenter={() => {
          // Keep dropdown open when hovering over it on desktop
        }}
        on:mouseleave={() => {
          if (browser && innerWidth >= 768) toggleDropdown(index, false);
        }}>
        <ul class="space-y-2 md:pl-0 md:mt-0 md:space-y-0">
          {#each navitem.subitems as subitem}
            <li>
              <a
                href={subitem.path}
                class="block px-3 py-2 md:py-3 m-0 text-sm text-gray-800 md:px-4 font-medium hover:bg-brand-light hover:text-white">
                {subitem.name}
              </a>
            </li>
          {/each}
        </ul>
      </div>
    {/if}
  {:else}
    <!-- Regular link -->
    <a
      href={navitem.path}
      class="block m-0 px-3 py-2 font-bold text-white visited:text-white hover:text-gray-200 text-nav md:text-nav md:h-full md:flex md:items-center {isActive
        ? 'md:border-b-2 md:border-white'
        : ''}">
      {navitem.name}
    </a>
  {/if}
</li>
